import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import axios from "axios";
import { motion, AnimatePresence } from "framer-motion";
import { Gift, X } from "lucide-react";

const KEY = "gioia-ref";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getRef = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "null"); } catch { return null; }
};

export const shareUrl = (code) => `${process.env.REACT_APP_BACKEND_URL}/api/share/amica/${code}`;

export const ReferralCapture = () => {
  const { search } = useLocation();
  const [ref, setRef] = useState(null);

  useEffect(() => {
    const code = new URLSearchParams(search).get("ref");
    if (!code || !process.env.REACT_APP_BACKEND_URL) return undefined;
    let alive = true;
    axios.get(`${API}/referrals/${encodeURIComponent(code)}`)
      .then((r) => {
        if (!alive || !r.data?.code) return;
        const v = { code: r.data.code, name: r.data.name ?? "" };
        localStorage.setItem(KEY, JSON.stringify(v));
        window.dispatchEvent(new Event("gioia-ref"));
        setRef(v);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [search]);

  return (
    <AnimatePresence>
      {ref && (
        <motion.div
          data-testid="referral-banner"
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ delay: 1.6, duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="fixed z-50 left-4 right-24 bottom-5 sm:left-7 sm:right-auto sm:max-w-md bg-[#14110F] text-[#F6F2EC] border border-[#C9A66B]/50 p-5 shadow-[0_30px_60px_-20px_rgba(0,0,0,0.6)]"
        >
          <button data-testid="referral-banner-close" onClick={() => setRef(null)} aria-label="Chiudi" className="absolute top-3 right-3 text-[#b8ad9f] hover:text-[#F6F2EC]"><X className="w-4 h-4" /></button>
          <div className="flex gap-4 pr-6">
            <Gift className="w-6 h-6 text-[#C9A66B] shrink-0 mt-1" strokeWidth={1.3} />
            <div>
              <p className="font-serif-d text-xl leading-tight">{ref.name ? `${ref.name} ti ha invitata da Gioia` : "Sei stata invitata da Gioia"}</p>
              <p className="mt-1 text-sm text-[#d9d0c4]">Prenota il tuo primo trattamento: una sorpresa ti aspetta. Il codice <span className="text-[#C9A66B]">{ref.code}</span> è già inserito.</p>
              <Link to="/#booking" onClick={() => setRef(null)} data-testid="referral-banner-book" className="mt-3 inline-block text-[0.7rem] tracking-[0.2em] uppercase text-[#C9A66B] underline underline-offset-4">Prenota ora</Link>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
